<template>
<div>
  <v-layout row class="ml-4 mt-4 mr-2">
    <div :class="ui.textHeadline">
      {{this.companyTitle2}} keys
    </div>
    <v-spacer/>
    <div :class="ui.responseShowXs">
      <v-btn flat icon small :color="ui.btnColor" :to="'/signin'">
        <v-icon dark>person</v-icon>
      </v-btn>
    </div>
    <div :class="ui.responseHideXs">
      <v-btn outline small :color="ui.btnColor" :to="'/signin'">
        <v-icon dark left>person</v-icon>
        sign in
      </v-btn>
    </div>
    <div :class="ui.responseShowXs">
      <v-btn flat icon small :color="ui.btnColor" :to="'/'">
        <v-icon dark>home</v-icon>
      </v-btn>
    </div>
    <div :class="ui.responseHideXs">
      <v-btn outline small :color="ui.btnColor" :to="'/'">
        <v-icon dark left>home</v-icon>
        home
      </v-btn>
    </div>
  </v-layout>
  <v-container>
    <v-layout>
    <v-flex xs12 sm6 lg4 offset-sm3 offset-lg4>
    <v-card>
      <v-img class="white--text" :height="ui.sizeHeightDialogSmall"
      :src="require('@/app/assets/images/nature13.jpg')">
       <v-container fill-height fluid>
         <v-layout fill-height>
           <v-flex xs12 align-end flexbox>
             <span :class="ui.textHeadlineLight"> {{this.message}} </span>
           </v-flex>
         </v-layout>
       </v-container>
     </v-img>
      <!-- note @submit and on Submit were added to prevent page reload. -->
      <v-form ref="form" v-model="valid" lazy-validation>
      <!-- <v-card-title>
        <div :class="ui.textHeadline">
          Password Reset
        </div>
      </v-card-title> -->
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
              v-model="email"
              :rules="emailRules"
              label="user email"
              prepend-icon="mail"
              @keyup.enter="validate"
              required>
              </v-text-field>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                v-model="systemPassword"
                label="system domain"
                prepend-icon="cloud"
                type="password"
                readonly
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout class="text-xs-left ml-3 mr-2 mt-2"
          v-if="this.message !== null">
            <div :class="ui.textSubheading"
            v-if="this.message === 'user password reset'">
              Please enter your email address which is associated with your Besea account.
            </div>
            <div :class="ui.textSubheading" v-else>
              {{this.message}}
            </div>
          </v-layout>
        </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn
            :color="ui.colorError"
            flat
            v-if="this.message !== 'user password reset'"
          >
            <v-icon left> warning </v-icon>
            email
          </v-btn>
          <v-spacer/>
          <div v-if="this.enableBtnSpinResetPassword === false">
            <v-btn
              :color="ui.colorWarning"
              flat
              @click="resetUser()"
              :disabled="!valid"
            >
              <v-icon left> vpn_key </v-icon>
              reset password
            </v-btn>
          </div>
          <div v-else>
            <BtnSpin :btnSpec="btnInfo1"/>
          </div>
        </v-card-actions>
        <v-layout row class="mt-4">
          <PublicFooterCard :data="{bkgd: 'white'}"/>
        </v-layout>
      </v-form>
      </v-card>
    </v-flex>
    </v-layout>
  </v-container>
</div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
import formSignup from "@/data/rules/mixins/formSignup.js";
import BtnSpin from "@/frame/animation/components/BtnSpin";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import publicGlobals from "@/data/globals/mixins/publicGlobals.js";
import PublicFooterCard from "@/public/components/PublicFooterCard";
import announcements from "@/frame/messages/mixins/announcements.js";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      valid: true,
      enableSpinner: false,
      enableBtnSpinResetPassword: false,
      message: "user password reset",
      systemPassword: "abcdef123456",
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user"
      }
    };
  },
  computed: {
    ...mapGetters(["getUser"])
  },
  components: {
    BtnSpin,
    PublicFooterCard
  },
  mixins: [formSignup, apptheme, publicGlobals, announcements],
  methods: {
    resetUser() {
      if (this.$refs.form.validate() === true) {
        // this.generateInfoSnackbar(this.ui.colorBlue1, "2");
        this.enableBtnSpinResetPassword = true;
        // eslint-disable-next-line
        let emailAddress = this.email;
        firebase
          .auth()
          .sendPasswordResetEmail(emailAddress)
          // eslint-disable-next-line
          .then(email => {
            this.$store.dispatch("enableBtnSpin", true); // stop spining
            this.enableSpinner = false; // go back to validate button
            this.$router.push("/newpassword");
          })
          .catch(error => {
            this.enableBtnSpinResetPassword = false;
            this.message = error.message;
          });
      }
    }
  }
};
</script>
